module.exports = __webpack_public_path__ + "img/glass.4dac56a1.png";